export const COMPLIANCE_CHECK_TYPE_MODEL = "compliance-check-type";

const complianceCheckTypeModel = {
  name: ""
};

export default complianceCheckTypeModel;
